import baseRequest from './baseRequest';

const baseEndpoint = '/api/public/request';

export interface LenderActivationParams {
  password: string;
}

export interface BorrowerActivationParams {
  acceptTermsAndEConsent: boolean;
  last4SSN: number;
  password: string;
  username: string;
}

export function submit(type: AccountRequestType, params: LenderActivationParams) {
  return baseRequest.post(`${baseEndpoint}/${type}`, params);
}

export function validate(type: AccountRequestType) {
  return baseRequest.get(`${baseEndpoint}/${type}`);
}

export function validateBorrower(userEmail: string) {
  return baseRequest.get(`${baseEndpoint}/check-activation/email?email=${encodeURIComponent(userEmail)}`);
}

export function activateBorrower(params: BorrowerActivationParams) {
  return baseRequest.post(`${baseEndpoint}/activate-borrower`, params);
}

export function requestPasswordReset(values) {
  return baseRequest.post('/api/public/_reset-password', values);
}

export function requestDormancyReset(values) {
  return baseRequest.post('/api/public/_reset-dormancy', values);
}
